var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"canva-btn",attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_c('CanvaIcon'),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }